import { ref, readonly } from "vue";

interface VideoOptions {
  videoUrl?: string;
  title?: string;
}

interface VideoState {
  isOpen: boolean;
  title: string;
  videoUrl: string;
  resolve: ((value: boolean) => void) | null;
}

// Create a shared state for the confirmation modal
const state = ref<VideoState>({
  isOpen: false,
  title: "",
  videoUrl: "",
  resolve: null,
});

export const useVideo = () => {
  const showVideo = (options: VideoOptions = {}): Promise<boolean> => {
    return new Promise((resolve) => {
      state.value = {
        isOpen: true,
        title: options.title || "Video Tutorial",
        videoUrl: options.videoUrl || "",
        resolve,
      };
    });
  };
  const closeVideo = () => {
    state.value.isOpen = false;
  };

  return {
    state: readonly(state),
    showVideo,
    closeVideo,
  };
};
